import React, { useState, useEffect } from "react";
import {
  Container, Card, CardContent, TextField, Button,
  Typography, Alert, InputAdornment, IconButton
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

const MIN_LEN = 10;

export default function SetPassword() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [show1, setShow1]       = useState(false);
  const [show2, setShow2]       = useState(false);
  const [error, setError]       = useState("");
  const [ok, setOk]             = useState("");
  const [saving, setSaving]     = useState(false);
  const navigate = useNavigate();

  const changeToken = sessionStorage.getItem("pwd_change_token");
  const changeUserId = sessionStorage.getItem("pwd_change_uid");

  useEffect(() => {
    if (!changeToken) navigate("/login", { replace: true });
  }, [changeToken, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setOk("");

    if (password.length < MIN_LEN) {
      setError(`Password must be at least ${MIN_LEN} characters.`);
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    if (!changeToken) {
      setError("Session expired. Please log in again.");
      navigate("/login", { replace: true });
      return;
    }

    try {
      setSaving(true);
      await api.post(
        "/auth/set-password",
        {
          user_id: changeUserId || undefined,
          password,
          password_confirmation: confirm,
        },
        { headers: { "X-Password-Change-Token": changeToken } }
      );

      setOk("Password updated. Please sign in.");
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      localStorage.removeItem("role");
      sessionStorage.removeItem("pwd_change_token");
      sessionStorage.removeItem("pwd_change_uid");

      setTimeout(() => navigate("/login", { replace: true }), 800);
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to set password.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 8 }}>
      <Card>
        <CardContent component="form" onSubmit={onSubmit}>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
            Set a new password
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {ok && <Alert severity="success" sx={{ mb: 2 }}>{ok}</Alert>}

          <TextField
            label="New password"
            type={show1 ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShow1(v => !v)} edge="end">
                    {show1 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            helperText={`Minimum ${MIN_LEN} characters`}
          />

          <TextField
            label="Confirm password"
            type={show2 ? "text" : "password"}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            fullWidth
            required
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShow2(v => !v)} edge="end">
                    {show2 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button variant="contained" type="submit" fullWidth disabled={saving}>
            {saving ? "Saving..." : "Save password"}
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}
